/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Lightbulb(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M176.00244,232a8.00039,8.00039,0,0,1-8,8h-80a8,8,0,1,1,0-16h80A8.00039,8.00039,0,0,1,176.00244,232Zm40-128a87.54306,87.54306,0,0,1-33.6416,69.208,16.23078,16.23078,0,0,0-6.3584,12.76758V192a16.01833,16.01833,0,0,1-16,16h-64a16.01833,16.01833,0,0,1-16-16v-6.03125A16.01813,16.01813,0,0,0,73.773,173.30957a87.57621,87.57621,0,0,1-33.76953-68.81445c-.2627-47.66211,38.26367-87.34961,85.88183-88.47071A88.00123,88.00123,0,0,1,216.00244,104Zm-32.78808-9.39648a55.85,55.85,0,0,0-45.76465-45.708,7.99953,7.99953,0,1,0-2.6543,15.77734A39.83978,39.83978,0,0,1,167.439,97.27734a8.00261,8.00261,0,0,0,7.87793,6.66407,8.103,8.103,0,0,0,1.34668-.11329A8,8,0,0,0,183.21436,94.60352Z" />
    </Svg>
  );
}

export default Lightbulb;
